var render, staticRenderFns
import script from "./wSlideDown.vue?vue&type=script&lang=js&"
export * from "./wSlideDown.vue?vue&type=script&lang=js&"
import style0 from "./wSlideDown.vue?vue&type=style&index=0&id=f31b5554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31b5554",
  null
  
)

export default component.exports